<template>
	<div class="post-page-container page" style="margin-top: -22px">
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
			<v-skeleton-loader v-if="this.isLoading" v-bind="attrs" type="card" />
			<div v-else-if="forum">
				<div class="d-flex justify-space-between">
					<div v-if="controlPanelIsVisible">
						<v-btn
							class="control-btn control-btn__edit elevation-0"
							@click="openEditPostModal"
						>
							Edit
						</v-btn>
					</div>
				</div>

				<Forum :forum="this.forum" />

				<div v-if="isShowCreatePostModal">
					<CreatePostModal
						v-on:closeModal="closeCreatePostModal"
						:show="isShowCreatePostModal"
						:categoryId="categoryId"
						:editableForum="forum"
						:edit="isEdit"
						@closeModal="closeCreatePostModal"
					/>
				</div>

				<v-btn
					v-show="isShowCreatePostButton"
					@click="openCreatePostModal"
					bottom
					right
					class="add-post-button"
					fixed
					fab
				>
					<v-icon>mdi-plus</v-icon>
				</v-btn>

				<v-btn v-show="isVisible" @click="scrollToTop" bottom right fixed fab>
					<v-icon>mdi-chevron-up</v-icon>
				</v-btn>
			</div>
		</div>
	</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

import Forum from '@/components/Forum/Forum.vue'
import CreatePostModal from '@/components/Modals/CreateForumPostModal.vue'
import penIcon from '@/assets/images/icon-pen.svg'
import PageBlocked from '@/components/PageBlocked'
import Block from '@/mixins/Block.js'
import Dwh from '@/mixins/Dwh'
import _ from 'lodash'

export default {
	name: 'ForumPage',
	mixins: [Block, Dwh],
	components: {
		CreatePostModal,
		Forum,
		PageBlocked,
	},
	data() {
		return {
			attrs: {
				elevation: 0,
			},
			penIcon,
			isVisible: false,
			isShowCreatePostButton: true,
			isShowCreatePostModal: false,
			isEdit: false,
			pageBlockedName: 'forums',
		}
	},
	computed: {
		...mapGetters('forum', ['forum', 'isLoading']),
		...mapGetters('auth', ['profile']),

		categoryId() {
			if (this.$route.params.id !== undefined) {
				return this.forum.category_id
			}

			return null
		},
		controlPanelIsVisible() {
			return this.profile.user_id === this.forum.user.user_id
		},
	},

	mounted() {
		window.addEventListener('scroll', this.toggleVisibility)
		window.addEventListener('resize', this.checkScreenWidth)
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.toggleVisibility)
		window.addEventListener('resize', this.checkScreenWidth)
	},

	methods: {
		...mapActions('forum', ['getForum']),
		toggleVisibility() {
			this.isVisible = window.scrollY > 1000
		},
		scrollToTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			})
		},
		checkScreenWidth() {
			this.isShowCreatePostButton = window.innerWidth >= 1264
		},
		openCreatePostModal() {
			this.isShowCreatePostModal = true
		},
		closeCreatePostModal() {
			this.isEdit = false
			this.isShowCreatePostModal = false
		},
		openEditPostModal() {
			this.isEdit = true
			this.openCreatePostModal()
		},
		getForumById() {
			this.getForum(this.$route.params.id)
		},
		toggleIsConfirmDeleteModalShow() {
			this.isConfirmDeleteModalShow = !this.isConfirmDeleteModalShow
		},
	},
	watch: {
		isLoading(newValue, oldValue) {
			if (newValue !== oldValue) {
				if (!newValue && this.$route.query.toBottom !== undefined) {
					setTimeout(() => {
						window.scrollTo({
							top: document.body.scrollHeight,
							behavior: 'smooth',
						})
					}, 100)
				}
			}
		},
		forum(newValue, oldValue) {
			if (!_.isEqual(newValue, oldValue)) {
				this.sendTrigger({
					category: 'Content',
					action: 'view_forum_post',
					module: 'Forums',
					data: newValue.forum_id,
					content_chapter_id: newValue.category.chapter_id
						? [newValue.category.chapter_id]
						: null,
				})
			}
		},
	},
	created() {
		if (this.$route.params.id !== undefined && (!this.isBlocked || this.isBlocked === null)) {
			this.getForumById()
		}
	},
}
</script>

<style lang="scss">
.post-page {
	&__divider {
		border-color: #000 !important;
		mix-blend-mode: normal;
		opacity: 0.1;
	}
}

@media screen and (min-width: 1200px) {
	.post-page-container {
		max-width: 100%;
		width: 100%;
	}
}

@media screen and (min-width: 1320px) {
	.post-page-container {
		max-width: 600px;
	}
}

.post {
	&__search {
		background: white;
		height: 54px;
		border-radius: 10px;
		border: 1px solid rgb(230, 230, 230);
		max-width: 600px;
	}

	&__fake-btn-modal {
		&-container {
			display: flex;
			align-items: center;
			justify-content: space-between;
			height: 54px;
			background: rgb(255, 255, 255);
			border: 1px solid rgb(230, 230, 230);
			border-radius: 10px;
			padding: 20px 15px;
			max-width: 600px;
			cursor: pointer;

			color: rgb(160, 160, 160);
			font-size: 15px;
			font-family: Montserrat, sans-serif;
			font-weight: normal;
			letter-spacing: -0.43px;
		}
	}

	@media screen and (max-width: 1264px) {
		&__search {
			max-width: none;
			width: 100%;
		}
		&__fake-btn-modal-container {
			max-width: none;
			width: 100%;
		}
	}
}

.control-btn {
	font-size: 14px;
	font-weight: 700;
	font-family: Montserrat, sans-serif;
	text-transform: capitalize;
	text-decoration: underline;
	background-color: transparent !important;
	line-height: 17.07px;

	&__edit {
		color: #0055a3 !important;
	}
}
</style>
